export default "__VITE_ASSET__B_Gf88z$__"